  import React, { useRef, useState, useEffect } from "react";
import VolumeOffIcon from '@mui/icons-material/VolumeOff';
import VolumeUpIcon from '@mui/icons-material/VolumeUp';
import IconButton from '@mui/material/IconButton';

// Move videoList OUTSIDE the component so it's not recreated on every render
const videoList = [
  "https://d3lwdqji776yyc.cloudfront.net/Videos/os+by+os+tralier+new+(1)+(1)+(1)+(1).mp4",
  "https://d3lwdqji776yyc.cloudfront.net/Videos/OWAIS+CLOTHES+3+fernando+(1)+(1)+(1)+(1).mp4",
  "https://d3lwdqji776yyc.cloudfront.net/Videos/os+by+os+david+cloth+1+reel+1-+(1)+(1).mp4",
]

function HeroVideo() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [muted, setMuted] = useState(true);
  const [hovered, setHovered] = useState(false);
  const videoRef = useRef(null);

  const toggleMute = () => {
    if (videoRef.current) {
      videoRef.current.muted = !muted;
      setMuted(!muted);
    }
  };

  const handleVideoEnd = () => {
    setCurrentIndex((prev) => (prev + 1) % videoList.length);
  };

 useEffect(() => {
  const video = videoRef.current;
  if (!video) return;

  const handleLoadedMetadata = () => {
    // Wait for seekable range to be ready
    const waitForSeekable = () => {
      if (video.seekable.length > 0) {
        if (currentIndex === 0) {
          video.currentTime = 3; // Crop first 3s for first video
        }
        video.play();
      } else {
        setTimeout(waitForSeekable, 50); // Retry after 50ms
      }
    };
    waitForSeekable();
  };

  video.addEventListener("loadedmetadata", handleLoadedMetadata);

  return () => {
    video.removeEventListener("loadedmetadata", handleLoadedMetadata);
  };
}, [currentIndex]);


  return (
    <div
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{ position: "relative", display: "inline-block" }}
    >
      <video
        ref={videoRef}
        src={videoList[currentIndex]}
        autoPlay
        muted={muted}
        playsInline
        onEnded={handleVideoEnd}
        preload="auto"
        className="center-video"
      />
      {hovered && (
        <IconButton
          onClick={toggleMute}
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            backgroundColor: "rgba(0,0,0,0.6)",
            color: "#fff",
            zIndex: 10,
            width: 64,
            height: 64,
          }}
        >
          {muted ? <VolumeOffIcon fontSize="large" /> : <VolumeUpIcon fontSize="large" />}
        </IconButton>
      )}
    </div>
  );
}

// ✅ Wrap with memo to prevent unnecessary re-renders
export default React.memo(HeroVideo);
